var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c(
        "div",
        { staticClass: "repeat-option-set repeat-option-set--summary" },
        [
          _c("span", { staticClass: "repeat-option-set-summary__label" }, [
            _vm._v(_vm._s(_vm.$t("calendar", "Summary")) + ":")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "repeat-option-set-summary__summary" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm._f("formatRecurrenceRule")(_vm.recurrenceRule, _vm.locale)
                ) +
                "\n\t"
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }